import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import InputControl from '../InputControl/InputControl';
import Api from '../../../services/Api';

const WebPageCitation = ({
  onRequestClose,
  onCitationAdded,
}) => {
  const [author, setAuthor] = useState(undefined);
  const [title, setTitle] = useState(undefined);
  const [url, setUrl] = useState(undefined);
  const [language, setLanguage] = useState(undefined);
  const save = () => {
    Api.post('types/citations', {
      author,
      title,
      url,
      language,
      resource_type_id: 5,
    }).then((response) => {
      if (response.status === 201) {
        if (onCitationAdded) {
          onCitationAdded(response.data);
        }
      }
    });
  };
  return (
    <div className="row">
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Author" placeholder="author..." value={author} onValueChanged={value => setAuthor(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Title" placeholder="title..." value={title} onValueChanged={value => setTitle(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="URL" placeholder="url..." value={url} onValueChanged={value => setUrl(value)} />
      </div>
      <div className="col-md-12 mb-2">
        <InputControl type="text" label="Language" placeholder="language..." value={language} onValueChanged={value => setLanguage(value)} />
      </div>
      <div className="col-md-12 text-end mt-2">
        <Button variant="warning" onClick={onRequestClose} className="me-3">
          Close
        </Button>
        <Button variant="dark" onClick={save}>
          Save Changes
        </Button>
      </div>
    </div>
  );
};

WebPageCitation.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  onCitationAdded: PropTypes.func.isRequired,
};

export default WebPageCitation;
